import React, {FC, ReactElement} from 'react';
import type {groupProps} from './Group';
import styled from 'styled-components';
import {GroupDesigned} from './Group';
import Element from '../elements/Element';


interface MainState {
}


const GroupDesignedEditor = styled(GroupDesigned)`
&.group {
   ${props => props.isDraggingOver &&`
      background: rgba(22, 118, 208, 0.05);
      border: 1px solid #1676D0;
      cursor: move;
  `};
  ${props => props.isDragging &&`
          cursor: move;
  `};
}
`;

const Group: FC<groupProps> = ({...props}): ReactElement => {

    const useAppSelector = props.editorPlugins.useAppSelector;
    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const selectActive = props.editorPlugins.selectActive;
    const selectActiveSet = props.editorPlugins.selectActiveSet;
    const openElementsLibrary = props.editorPlugins.openElementsLibrary;
    const Add = props.editorPlugins.addButton;
    const Droppable = props.editorPlugins.droppable;

    const dispatch = useAppDispatch();
    const activePath: any = useAppSelector((state: any) => state.editor.present.activePath);


    function getPath(index: number) {
        if (!props.path) return null;
        let path = {...props.path};
        path.elementIndex = index;
        return path;
    }

    function isGroupActive() {
        if (!activePath) return false;
        let path = {...activePath};
        path.elementIndex = null;
        let groupPath: any = props.path;
        if (!groupPath) return false;
        return JSON.stringify(path) === JSON.stringify(groupPath);
    }

    function clickOpenElementsLibrary() {
        let path = {...props.path};
        path.elementIndex = -1;
        dispatch(selectActive(path));
        let data = {
            path: path,
            type: 'element'
        };
        dispatch(selectActiveSet(''));
        return dispatch(openElementsLibrary(data));
    }

    return (
        <Droppable droppableId={props.path?.slideIndex + '-' + props.path?.comboIndex + '-' + props.path?.setIndex + '-' + props.path?.groupIndex} type={'element'}>
            {(provided:any, snapshot:any) => (
                <GroupDesignedEditor
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    isDraggingOver={snapshot.isDraggingOver} isDragging={snapshot.isDragging} mobileOrder={props.mobileOrder}
                    className={'group  pos-' + props.index + (isGroupActive() && props.elements.length && activePath.elementIndex !== null ? ' activeGroup ' : ' no-active-element ') + (!props.elements.length ? ' no-elements' : '')}
                    width={props.width}
                >
                    {
                        props.elements.map((element: any, index: number) => {
                            return <Element key={index} index={index} path={getPath(index)} editorPlugins={props.editorPlugins} elementData={element}/>;
                        })
                    }
                    {provided.placeholder}
                </GroupDesignedEditor>
            )}
        </Droppable>
    );
};

Group.defaultProps = {};

export default Group;


